import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";
import { isDevMode } from "./authConfig";

const ProtectedRoute = ({ children, requiredRole, allowedRoles }) => {
  const { auth } = useAuth();
  
  // 🔥 DEV MODE: Her zaman geçir
  if (isDevMode()) {
    console.log("🔥 DEV MODE: ProtectedRoute bypassed");
    return children;
  }

  // Production mode: Normal kontrol
  const user = JSON.parse(localStorage.getItem("user"));

  if (!auth.isAuthenticated) {
    return <Navigate to="/supplier-login" replace />;
  }

  // ✅ Tek rol kontrolü
  if (requiredRole && user?.role !== requiredRole) {
    console.warn(`❌ Access denied. Required: ${requiredRole}, User: ${user?.role}`);
    return <Navigate to="/" replace />;
  }

  // ✅ Çoklu rol kontrolü
  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    console.warn(`❌ Access denied. Allowed: ${allowedRoles.join(', ')}, User: ${user?.role}`);
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
